// extracted by mini-css-extract-plugin
module.exports = {"buttonCaption":"book_button_buttonCaption__iqwgU"};